import { render, staticRenderFns } from "./contractDetailRoom.vue?vue&type=template&id=969fb956&scoped=true"
import script from "./contractDetailRoom.vue?vue&type=script&lang=js"
export * from "./contractDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./contractDetailRoom.vue?vue&type=style&index=0&id=969fb956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969fb956",
  null
  
)

export default component.exports